<template>
  <div>
    <div
      style="
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 50px;
        background-color: white;
        padding-left: 20px;
        padding-top: 20px;
        margin-bottom: 20px;
      "
    >
      <div style="display: flex">
        <el-select v-model="selectKey" placeholder="" style="width: 100px" @change="selectKeyChange">
          <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <el-select
          v-model="selectValue"
          clearable
          filterable
          placeholder="请输入"
          :remote="true"
          :remote-method="getModelList"
          :disabled="selectKey.length === 0"
          :loading="remoteLoading"
          style="width: 230px"
        >
          <el-option v-for="item in modelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <div style="padding-left: 20px; font-size: 13px; height: 38px; line-height: 38px; color: gray">
          操作前请先将车辆上电或启动
        </div>
      </div>
      <div
        v-if="carState == '在线'"
        class="status-icon nx-margin-t nx-flex-center-center"
        style="
          width: 100px;
          height: 38px;
          border-radius: 5px;
          line-height: 38px;
          background: #f6fbf3;
          margin-right: 50px;
        "
      >
        <img src="@/assets/images/online.png" style="width: 20px; height: 20px" alt="" />
        <span class="nx-margin-small-l" style="font-size: 16px; color: #606266; font-weight: 500">{{ carState }}</span>
      </div>
      <div
        v-if="carState == '离线'"
        class="status-icon nx-margin-t nx-flex-center-center"
        style="
          width: 100px;
          height: 38px;
          border-radius: 5px;
          line-height: 38px;
          background: #f7f7f8;
          margin-right: 50px;
        "
      >
        <img src="@/assets/images/offline.png" style="width: 20px; height: 20px" alt="" />
        <span class="nx-margin-small-l" style="font-size: 16px; color: #606266; font-weight: 500">{{ carState }}</span>
      </div>
    </div>
    <div style="background-color: white; width: 100%; height: 470px">
      <div style="display: flex; justify-content: space-between; height: 30px; box-sizing: border-box;">
        <div class="topLab">下发指令</div>
        <div style="margin-top: 12px !important; margin-right: 28px">
          <el-button
            :disabled="carState != '在线'"
            @click="handSend"
            icon="el-icon-upload"
            style="color: #0080f6; border: 1px solid #0080f6"
            >{{ '下发' }}</el-button
          >
          <el-button @click="adds" icon="el-icon-plus" type="primary" :disabled="addBtnDisable">添加指令</el-button>
        </div>
      </div>
      <div style="overflow-y: scroll; height: 420px; margin-top: 15px">
        <div v-for="(item, index) in itemList" :key="index" class="commonView">
          <el-button
            v-if="itemList.length > 1"
            icon="el-icon-close"
            @click="remove(index)"
            class="custom-button"
          ></el-button>
          <div style="height: 10px"></div>
          <div style="margin-left: 20px">
            <nx-form ref="formRef" :source="item.form" :config="item.config">
              <!-- 这里放入每个视图的内容 -->
              <template slot="instructionType">
                <div style="display: flex">
                  <el-radio-group v-model="item.form.commandType" style="margin-top: 10px" @change="changeComandType(index,$event)">
                    <el-radio label="1">排除故障</el-radio>
                    <el-radio label="2">读取故障</el-radio>
                    <el-radio label="3">读取DiD</el-radio>
                  </el-radio-group>
                  <template v-if="item.form.commandType === '3'">
                    <!--          急加速阈值-->
                    <el-input
                      v-model="item.form.didList"
                      style="width: 290px; margin-left: 10px; font-size: 11px"
                      placeholder="请输入16进制DID,两个DID之间用;分割 比如FF;DD"
                    ></el-input>
                  </template>
                </div>
              </template>
              <template slot="diagnosticItemsView">
                <el-select v-model="item.form.udsItem" @change="changeUdsItem(index, $event)">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </template>
              <template slot="tempLableView"> </template>
              <template slot="canInputView">
                <div>
                  <el-input
                    v-model="item.form.requestCanId"
                    style="width: 300px"
                    placeholder="请输入16进制大写字符串"
                    :disabled="item.form.requestCanIdAble"
                  ></el-input>
                </div>
              </template>
              <template slot="responseInputView">
                <div>
                  <el-input
                    v-model="item.form.responseCanId"
                    style="width: 300px"
                    placeholder="请输入16进制大写字符串"
                    :disabled="item.form.responseCanIdAble"
                  ></el-input>
                </div>
              </template>

              <!-- <template slot="requestCollectMethodView"> 
                  <el-radio-group v-model="item.form.requestCollectMethod" style="margin-top: 10px">
                    <el-radio label="0">原始数据</el-radio>
                    <el-radio label="1">采集区间平均值</el-radio>
                  </el-radio-group>
              </template> -->
            </nx-form>
          </div>
        </div>
      </div>
    </div>

    <div class="bottomView">
      <div style="display: flex; justify-content: space-between">
        <div
          style="
            margin-left: 20px;
            margin-top: 20px;
            font-size: 16px;
            height: 20px;
            border-left: 3px solid #0080f6;
            padding-left: 8px;
          "
        >
          终端响应情况
        </div>
        <div style="margin-top: 10px; margin-right: 10px">
          <el-button icon="iconfont icon-daochu_blue" type="primary" @click="handExport()"
            >{{ '导出' }}
          </el-button>
        </div>
      </div>
      <div style="display: flex">
        <div style="flex: 2; height: 380px; border-right: 1px solid #dcdfe6; overflow-y: scroll">
          <div style="margin: 20px">
            <div
              v-for="(item, index) in dataList"
              :key="index"
              style="margin-bottom: 6px"
              @click="dataSectionSelect(index)"
            >
              <div
                v-if="item.executeStatus === 0"
                style="
                  height: 36px;
                  display: flex;
                  background-color: blanchedalmond;
                  display: flex;
                  padding: 5px;
                  background: #f3f4f5;
                  border-radius: 2px;
                "
              >
                <div style="display: flex">
                  <el-tag style="margin-top: 5px">{{ '下发中' }}</el-tag>
                  <div style="font-size: 12px; line-height: 36px; height: 36px; margin-left: 16px" class="titelStyle">
                    {{ '消息流水号：' + item.serialNo }}
                  </div>
                </div>
              </div>
              <div
                v-if="item.executeStatus === 1"
                style="
                  height: 36px;

                  background-color: blanchedalmond;
                  display: flex;
                  background: #f3f4f5;
                  border-radius: 2px;
                  padding: 5px;
                "
              >
                <el-tag style="margin-top: 5px">{{ '执行中' }}</el-tag>
                <div style="font-size: 12px; line-height: 36px; height: 36px; margin-left: 16px" class="titelStyle">
                  {{ '消息流水号：' + item.serialNo }}
                </div>
              </div>
              <div
                @click="touchSuceess(index)"
                v-if="item.executeStatus === 2"
                style="
                  height: 36px;
                  background-color: #f3f4f5;
                  display: flex;
                  padding: 5px;
                  background: #f3f4f5;
                  border-radius: 4rpx;
                  justify-content: space-between;
                "
              >
                <div style="display: flex">
                  <el-tag type="success" style="margin-top: 5px">{{ '成功' }}</el-tag>
                  <div style="font-size: 12px; line-height: 36px; height: 36px; margin-left: 16px" class="titelStyle">
                    {{ '消息流水号：' + item.serialNo }}
                  </div>
                </div>

                <div style="display: flex; font-size: 12px; line-height: 36px; height: 36px; margin-left: 5px">
                  <div style="margin-right: 10px">{{ '数据项个数:' }}</div>
                  <div style="color: #0080f6; margin-right: 10px">{{ item.collectItemCount }}</div>
                  <div style="margin-right: 10px">{{ 'CAN数据采集时间:' }}</div>
                  <div style="color: #36383b; margin-right: 5px">{{ $utils.formatDate(item.responseTime) }}</div>
                  <div>
                    <img
                      :style="{ width: '36px', height: '36px', transform: `rotate(${item.rotateDegrees}deg)` }"
                      src="@/assets/images/uds-pull.png"
                    />
                  </div>
                </div>
              </div>
              <div v-show="item.canShowSucees" style="height: 237px; text-align: center" class="shouxin">
                <el-table
                  :data="item.recordList"
                  style="width: 100%"
                  stripe
                  :header-cell-style="{ color: '#999', backgroundColor: '#FAFAFA;' }"
                  fit
                  header-align="center"
                >
                  <el-table-column type="index" label="序号"> </el-table-column>
                  <el-table-column prop="commandType" label="指令">
                    <template slot-scope="{ row }">
                      <div>{{ getCommonType(row.commandType) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="requestCanId" label="请求CAN_ID"> </el-table-column>
                  <el-table-column prop="udsResult" label="诊断结果">
                    <template slot-scope="{ row }">
                      <el-button type="text" v-if="row.udsResult == 1">
                        {{ '成功' }}
                      </el-button>

                      <el-button type="text" style="color: red" v-if="row.udsResult != 1">
                        {{ '失败' }}
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column prop="address" label="结果详情">
                    <template slot-scope="{ row }">
                      <el-button
                        type="text"
                        v-if="row.udsResult == 1 && row.commandType != 1"
                        @click="showRightList(row)"
                      >
                        {{ '查看详情' }}
                      </el-button>
                      <div v-if="row.udsResult != 1">
                        {{ row.resultDesc }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div
                v-if="item.executeStatus === 3"
                style="
                  height: 36px;
                  background-color: #f3f4f5;
                  display: flex;
                  padding: 5px;
                  background: #f3f4f5;
                  border-radius: 4rpx;
                  justify-content: space-between;
                "
              >
                <div style="display: flex">
                  <el-tag type="danger" style="margin-top: 5px">{{ '失败' }}</el-tag>
                  <div style="font-size: 12px; line-height: 36px; height: 36px; margin-left: 16px" class="titelStyle">
                    {{ '消息流水号：' + item.serialNo }}
                  </div>
                </div>

                <div style="display: flex; font-size: 12px; line-height: 36px; height: 36px; margin-left: 5px">
                  <div style="margin-right: 10px">{{ '数据项个数:' }}</div>
                  <div style="color: #0080f6; margin-right: 10px">{{ item.collectItemCount }}</div>
                  <div style="margin-right: 10px">{{ 'CAN数据采集时间:' }}</div>
                  <div style="color: #36383b; margin-right: 10px">{{ $utils.formatDate(item.responseTime) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="flex: 1; height: 400px;">
          <nx-table ref="nxTable" :data="rightItemList" @search="search" table-title="" style="padding-top:  0px !important;" :operation="false" :height="400">
            <el-table-column v-if="rightType === 2" label="故障码类型" prop="faultCodeType"/>
            <el-table-column v-if="rightType === 2" label="DTC信息" prop="dtc" />
            <el-table-column v-if="rightType === 3" label="DID参数" prop="didParam" />
            <el-table-column v-if="rightType === 3" label="DID值" prop="didData" />
          </nx-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iccidSelect from '@/views/baseInfo/components/iccidSelect.vue'; // iccid
import { vinList } from '@/api/baseInfo/recordVehicleInfo.js';
import { getFindByVin } from '@/api/public.js';
import { getAllIccid } from '@/api/baseInfo/index.js';
import { getSnList } from '@/api/public';
import {
  getDeviceInfo,
  udsAddTask,
  udsTaskResult,
  getUdsItemList,
  exportUdsItemList,
} from '@/api/dataService/udsV2.js';
import { addTaskShort } from '@/api/safe/jsatl';


import { getUdsTaskRecordList } from '@/api/dataService/uds';

export default {
  name: '',
  data() {
    return {
      carState: '',
      carStateTimer: '',
      selectKey: 'vin',
      resetKey: 'vin',
      selectValue: '',
      remoteLoading: false,
      modelList: [],
      itemList: [],
      addBtnDisable: false,
      rightItemList: [],
      recordId: '',
      rightType: 0,
      dataList: [], //当前指令任务数组

      searchForm: {
        vin: '',
        iccid: '',
        deviceNum: '',
      },
    };
  },
  computed: {
    typeList() {
      return [
        { label: "VIN", value: 'vin' },
        { label: "ICCID", value: 'iccid' },
        { label: "设备号", value: 'sn' },
      ];
    },
    options() {
      return [
        {
          value: '0',
          label: '自定义',
        },
        {
          value: '1',
          label: '发动机',
        },
        {
          value: '2',
          label: 'vcu',
        },
        {
          value: '3',
          label: 'amt',
        },
      ];
    },
  },
  watch: {
    selectValue: {
      handler(value) {
        if (value) {
          this.getDevicesInfo();
        } else {
          this.carState = '';
          console.log('清除数据');
          this.dataList.splice(0, this.dataList.length);
          this.recordId = '';
          this.rightItemList = [];
        }
      },
    },
  },
  mounted() {
    this.initSetting();
    //初始化查询数据
    this.carStateTimer = setInterval(() => {
      console.log('检测状态计时器');
      if (this.selectValue.length > 0) {
        this.getDevicesInfo();
      } else {
        //this.initSetting();
        this.carState = '';
        console.log('清除数据');
        this.dataList.splice(0, this.dataList.length); //不在线 或者清空搜索框直接清空
        this.recordId = '';
         this.rightItemList = [];
      }
    }, 10000);
  },
  methods: {

    changeComandType(index,value) { 
   
       if (value != 3) { 
        this.itemList[index].form.didList = ''; 
      } else {
       
      }
      // console.log(this.itemList[index].config.didList);
    },
    async handExport() {
      console.log('导出');
      if (this.recordId) {
        const recoId = this.recordId;
        const params = {
          recordId: recoId,
        };
        await exportUdsItemList(params);
        this.$message.success('导出任务已提交，请前往导出文件列表查看');
      }
    }, //右侧数据导出
    async search(pagination) {
      const { pageNum, pageSize } = pagination;
      console.log(this.recordId);
      console.log("确实过来了");
      if (this.recordId) {
        const recoId = this.recordId;
        const params = {
          recordId: recoId,
          pageNum,
          pageSize,
        };
        const { data } = await getUdsItemList(params);
        this.rightItemList = data.list;
        pagination.total = data.total;
      }
    },
    showRightList(row) {
      //展示右侧的数据类型
      console.log(row);
      console.log("点击了详情数据");
      this.rightType = row.commandType;
      this.recordId = row.id ?? '';
      this.$refs.nxTable.search(1);
    },
    getCommonType(type) {
      if (type == 1) {
        return '清除故障';
      } else if (type == 2) {
        return '读取故障';
      } else {
        return '读取did';
      }
    },
    async timeChcek() {
      //定时轮训下发的taskId
      let realItemList = this.dataList.filter((item) => {
        // 在这里编写你的过滤条件，返回 true 表示符合条件，会被保留在过滤后的数组中
        return item.executeStatus == 0 || item.executeStatus == 1; //符合正在下发的和执行中的数据
      });
      this.addBtnDisable = true;
      if (realItemList.length > 0) {
        let realTaskIds = realItemList.map((item) => {
          return item.taskId; // 替换为你想要提取的内部字段名
        });
        let param = {
          vin: this.selectKey === 'vin' ? this.selectValue : '',
          taskIdList: realTaskIds,
        };
        if (this.selectKey === 'vin') {
          //
          param = {
            vin: this.selectValue,
            taskIdList: realTaskIds,
          };
        } else if (this.selectKey === 'iccid') {
          param = {
            iccid: this.selectValue,
            taskIdList: realTaskIds,
          };
        } else {
          param = {
            sn: this.selectValue,
            taskIdList: realTaskIds,
          };
        }

        const { data } = await udsTaskResult(param);
        if (data) {
          for (let index = 0; index < data.length; index++) {
            const returnItem = data[index];
            for (let j = 0; j < this.dataList.length; j++) {
              const currenItem = this.dataList[j];
              if (returnItem.taskId === currenItem.taskId) {
                console.log('进来了为啥不能变化呢');
                console.log(returnItem.taskResult.executeStatus);
                currenItem.executeStatus = returnItem.taskResult.executeStatus;
                currenItem.recordList = returnItem.taskResult.recordList;
                currenItem.responseTime = returnItem.taskResult.responseTime;
                currenItem.collectItemCount = returnItem.taskResult.collectItemCount;
              }
            }
          }
        }
      }
      this.addBtnDisable = false;

      //udsTaskResult
    },
    touchSuceess(index) {
      console.log('jin入了');
      let item = this.dataList[index];
      if (item.rotateDegrees == 0) {
        item.canShowSucees = true;
        item.rotateDegrees = 180;
      } else {
        item.canShowSucees = false;
        item.rotateDegrees = 0;
      }
    },
    changeUdsItem(index, value) {
      console.log(index);
      console.log(value);
      if (value != 0) {
        this.itemList[index].form.itemCanEdit = true;
        this.itemList[index].form.requestCanIdAble = true;
        this.itemList[index].form.responseCanIdAble = true;
      } else {
        this.itemList[index].form.itemCanEdit = false;
        this.itemList[index].form.requestCanIdAble = false;
        this.itemList[index].form.responseCanIdAble = false;
      }
    },
    async handSend() {
      var itemJsonList = [];
      if (this.itemList.length > 0) {
        var canGo = true;
        const formRefs = this.$refs.formRef;
        console.log(formRefs);
        for (let index = 0; index < this.itemList.length; index++) {
          //const formInstance = this.$refs[this.getRefName(index)];

          if (Array.isArray(formRefs)) {
            // 如果有多个表单组件
            const form = formRefs[index]; // 获取特定索引的表单组件
            const valid = await form.validate();
            if (!valid) {
              canGo = false;
              return;
            }
            try {
              const element = this.itemList[index];
              var kindmodel = { ...element.form };

              //   const isEmpty = Object.values(kindmodel).every((value) => value === '');
              if (
                kindmodel['commandType'] === '3' &&
                (kindmodel['didList'] === null || kindmodel['didList'] === undefined || kindmodel['didList'] === '')
              ) {
                canGo = false;
                this.$message.warning('请输入正确的DID');
                return;
              }
            } catch (error) {
              console.log(error);
            }
          } else {
          }
        }

        if (canGo) {
          for (let index = 0; index < this.itemList.length; index++) {
            const element = this.itemList[index];
            var kindmodel = { ...element.form };

            //   const isEmpty = Object.values(kindmodel).every((value) => value === '');
            if (kindmodel['commandType'] === '3') {
              kindmodel['didList'] = kindmodel['didList'].split(';');
            } else { 
              kindmodel["didList"] = [];
            }
            itemJsonList.push({ ...kindmodel });
          }

          let param = {
            vin: this.selectKey === 'vin' ? this.selectValue : '',
            configDto: itemJsonList,
          };
          if (this.selectKey === 'vin') {
            //
            param = {
              vin: this.selectValue,
              configDto: itemJsonList,
            };
          } else if (this.selectKey === 'iccid') {
            param = {
              iccid: this.selectValue,
              configDto: itemJsonList,
            };
          } else {
            param = {
              sn: this.selectValue,
              configDto: itemJsonList,
            };
          }
          this.postAddTask(param);
        }
      }
    },

    dataSectionSelect(index) {}, //废弃
    async postAddTask(itemParam) {
      const { data } = await udsAddTask(itemParam);
      if (data) {
        let sb = {
          ...data,
          canShowSucees: false,
          recordList: [],
          collectItemCount: 0,
          responseTime: 0,
          rotateDegrees: 0,
        };
        this.dataList.push(sb);
        console.log(this.dataList);
      }
    }, //上传指令
    adds() {
      const model = {
        tag: 0,
        form: {
          commandType: null, // 指令类型 // 1:清除故障 2：读取故障 3：读取did：
          udsItem: '0', //诊断项目 //0:自定义 1：发送机 2：vcu 3:amt
          didList: null, //did
          tempL: '',
          tempR: '',
          requestCanId: null, // request-CANid
          requestCanIdAble: false,
          requestCollectMethod: null, //数据采集方式 0：原始数据 1：采集区间平均值
          requestFrameType: null, //  request-祯类型  0:标准帧 1：扩展帧
          requestChannelId: null, // request-通道号 0:can1 1:can2
          responseCanId: null, // response-CANid
          responseCanIdAble: false,
          responseCollectMethod: null, // response-数据采集方式 0：原始数据 1：采集区间平均值
          responseFrameType: null, // response-祯类型 0:标准帧 1：扩展帧
          responseChannelId: null, // response-通道号 0:can1 1:can2
          itemCanEdit: false,
        },
        config: [
          {
            key: 'commandType',
            component: 'slot',
            slotName: 'instructionType',
            showL: 1,
            span: 12,
            
            itemClass: 'sb',
            label: '指令类型:', //指令类型
            itemProps: {
              rules: [
                {
                  required: true,
                  validator: (rule, value, callback) => {
                    console.log(value);
                    callback();
                  },
                  trigger: 'change',
                },
                { required: true, message: '请选择指令类型', trigger: 'blur' },
              ],
            },
          },
          {
            key: 'udsItem',
            component: 'slot',
            slotName: 'diagnosticItemsView',
            span: 12,
         
            label: '诊断项:', //诊断项
            itemClass: 'sb',
            showL: 1,
            itemProps: {
              rules: [
                {
                  required: true,
                  validator: (rule, value, callback) => {
                    callback();
                  },
                  trigger: 'blur',
                },
              ],
            },
          },

          {
            key: 'tempL',
            component: 'slot',
            slotName: 'tempLableView',
            span: 12,
            itemStyle: 0,
            itemClass: 'sb',
       
            label: '请求CAN_ID:', //诊断项
            showL: 1,
            itemProps: {
              rules: [
                {
                  required: true,
                  validator: (rule, value, callback) => {
                    console.log('切换了数据');
                    callback();
                  },
                  trigger: 'blur',
                },
              ],
            },
          },
          {
            key: 'tempR',
            component: 'slot',
            slotName: 'tempLableView',
            itemStyle: 0,
            showL: 1,
            span: 12,
           
            itemClass: 'sb',
            label: '反馈CAN_ID:', //诊断项
            props: {},
            itemProps: {
              rules: [
                {
                  required: true,
                  validator: (rule, value, callback) => {
                    console.log('切换了数据');
                    callback();
                  },
                  trigger: 'blur',
                },
              ],
            },
          },
          {
            key: 'requestCanId',
            component: 'slot',
            itemStyle: 1,
            slotName: 'canInputView',
            span: 12,
            label: 'CAN接口请求ID:', // CAN接口请求ID
            labelWidth: 'auto',
            props: {
              placeholder: '请输入CAN总线请求ID',
            },
            itemProps: {
              rules: [
                { required: true, message: '请输入', trigger: 'blur' },
                {
                  validator: (rule, value, callback) => {
                    if (value && !/^[0-9A-F]{8}$/.test(value)) {
                      return callback(new Error('请输入8位长度16进制大写字符串'));
                    }
                    callback();
                  },
                  trigger: 'blur',
                },
              ],
            },
          }, //responseInputView

          {
            key: 'responseCanId',
            component: 'slot',
            itemStyle: 1,
            slotName: 'responseInputView',
            span: 12,
            itemClass: 'gray',
            label: 'CAN接口请求ID:', // CAN接口请求ID
            labelWidth: 'auto',
            props: {
              placeholder: '请输入CAN总线请求ID',
            },
            itemProps: {
              rules: [
                { required: true, message: '请输入', trigger: 'blur' },
                {
                  validator: (rule, value, callback) => {
                    if (value && !/^[0-9A-F]{8}$/.test(value)) {
                      return callback(new Error('请输入8位长度16进制大写字符串'));
                    }
                    callback();
                  },
                  trigger: 'blur',
                },
              ],
            },
          },
          {
            key: 'requestCollectMethod',
            component: 'el-radio-group',
            span: 12,
            itemStyle: 1,
            itemClass: 'gray',
            
            tsbKey: '',
            label: '数据采集方式' + `:`,
            disableKey: 'itemCanEdit',
            data: [
              { value: 0, label: '原始数据' },
              { value: 1, label: '采集区间的平均值' },
            ],
            itemProps: {
              rules: [
                {
                  required: true,
                  message: '请选择',
                  trigger: 'change',
                },
              ],
            },
          },

          {
            key: 'responseCollectMethod',
            component: 'el-radio-group',
            span: 12,
            itemStyle: 1,
            itemClass: 'gray',
            
            label: '数据采集方式' + `:`,
            disableKey: 'itemCanEdit',
            props: {},
            data: [
              { value: 0, label: '原始数据' },
              { value: 1, label: '采集区间的平均值' },
            ],
            itemProps: {
              rules: [
                {
                  required: true,
                  message: '请选择',
                  trigger: 'change',
                },
              ],
            },
          },

          {
            key: 'requestFrameType',
            component: 'el-radio-group',
            span: 12,
            
            label: '桢类型' + `:`,
            itemStyle: 1,
            itemClass: 'gray',
            disableKey: 'itemCanEdit',
            props: {},
            data: [
              { value: 0, label: '标准桢' },
              { value: 1, label: '扩展桢' },
            ],
            itemProps: {
              rules: [
                {
                  required: true,
                  message: '请选择',
                  trigger: 'change',
                },
              ],
            },
          },
          {
            key: 'responseFrameType',
            component: 'el-radio-group',
            span: 12,
            itemClass: 'gray',
           
            disableKey: 'itemCanEdit',
            label: '桢类型' + `:`,
            itemStyle: 1,
            props: {},
            data: [
              { value: 0, label: '标准桢' },
              { value: 1, label: '扩展桢' },
            ],
            itemProps: {
              rules: [
                {
                  required: true,
                  message: '请选择',
                  trigger: 'change',
                },
              ],
            },
          },

          {
            key: 'requestChannelId',
            component: 'el-radio-group',
            span: 12,
           
            itemClass: 'gray',
            label: 'CAN通道号' + `:`,
            itemStyle: 1,
            disableKey: 'itemCanEdit',
            props: {},
            data: [
              { value: 0, label: 'CAN1' },
              { value: 1, label: 'CAN2' },
            ],
            itemProps: {
              rules: [
                {
                  required: true,
                  message: '请选择',
                  trigger: 'change',
                },
              ],
            },
          },
          {
            key: 'responseChannelId',
            component: 'el-radio-group',
            span: 12,
            itemStyle: 1,
            
            label: 'CAN通道号' + `:`,
            props: {},
            disableKey: 'itemCanEdit',
            itemClass: 'gray',
            data: [
              { value: 0, label: 'CAN1' },
              { value: 1, label: 'CAN2' },
            ],
            itemProps: {
              rules: [
                {
                  required: true,
                  message: '请选择',
                  trigger: 'change',
                },
              ],
            },
          },
        ],
      };
      this.itemList.push(model);
    }, //添加新指令
    initSetting() {
      this.itemList.splice(0, this.itemList.length);
      const model = {
        tag: 0,
        form: {
          commandType: null, // 指令类型 // 1:清除故障 2：读取故障 3：读取did：
          udsItem: '0', //诊断项目 //0:自定义 1：发送机 2：vcu 3:amt
          didList: null, //did
          tempL: '',
          tempR: '',
          requestCanId: null, // request-CANid
          requestCanIdAble: false,
          requestCollectMethod: null, //数据采集方式 0：原始数据 1：采集区间平均值
          requestFrameType: null, //  request-祯类型  0:标准帧 1：扩展帧
          requestChannelId: null, // request-通道号 0:can1 1:can2
          responseCanId: null, // response-CANid
          responseCanIdAble: false,
          responseCollectMethod: null, // response-数据采集方式 0：原始数据 1：采集区间平均值
          responseFrameType: null, // response-祯类型 0:标准帧 1：扩展帧
          responseChannelId: null, // response-通道号 0:can1 1:can2
          itemCanEdit: false,
        },
        config: [
          {
            key: 'commandType',
            component: 'slot',
            slotName: 'instructionType',
            showL: 1,
            span: 12,
          
            itemClass: 'sb',
            label: '指令类型:', //指令类型
            itemProps: {
              rules: [
                {
                  required: true,
                  validator: (rule, value, callback) => {
                    console.log(value);
                    callback();
                  },
                  trigger: 'change',
                },
                { required: true, message: '请选择指令类型', trigger: 'blur' },
              ],
            },
          },
          {
            key: 'udsItem',
            component: 'slot',
            slotName: 'diagnosticItemsView',
            span: 12,
            label: '诊断项:', //诊断项
         
            itemClass: 'sb',
            showL: 1,
            itemProps: {
              rules: [
                {
                  required: true,
                  validator: (rule, value, callback) => {
                    console.log('切换了数据');
                    callback();
                  },
                  trigger: 'blur',
                },
              ],
            },
          },

          {
            key: 'tempL',
            component: 'slot',
            slotName: 'tempLableView',
            span: 12,
            itemStyle: 0,
            itemClass: 'sb',
            label: '请求CAN_ID:', //诊断项
            showL: 1,
            itemProps: {
              rules: [
                {
                  required: true,
                  validator: (rule, value, callback) => {
                    console.log('切换了数据');
                    callback();
                  },
                  trigger: 'blur',
                },
              ],
            },
          },
          {
            key: 'tempR',
            component: 'slot',
            slotName: 'tempLableView',
            itemStyle: 0,
            showL: 1,
            span: 12,
            itemClass: 'sb',
            label: '反馈CAN_ID:', //诊断项
            props: {},
            itemProps: {
              rules: [
                {
                  required: true,
                  validator: (rule, value, callback) => {
                    console.log('切换了数据');
                    callback();
                  },
                  trigger: 'blur',
                },
              ],
            },
          },
          {
            key: 'requestCanId',
            component: 'slot',
            itemStyle: 1,
            slotName: 'canInputView',
            span: 12,
            label: 'CAN接口请求ID:', // CAN接口请求ID
            labelWidth: 'auto',
            props: {
              placeholder: '请输入CAN总线请求ID',
            },
            itemProps: {
              rules: [
                { required: true, message: '请输入', trigger: 'blur' },
                {
                  validator: (rule, value, callback) => {
                    if (value && !/^[0-9A-F]{8}$/.test(value)) {
                      return callback(new Error("请输入8位长度16进制大写字符串"));
                    }
                    callback();
                  },
                  trigger: 'blur',
                },
              ],
            },
          }, //responseInputView

          {
            key: 'responseCanId',
            component: 'slot',
            itemStyle: 1,
            slotName: 'responseInputView',
            span: 12,
            itemClass: 'gray',
            label: 'CAN接口请求ID:', // CAN接口请求ID
            labelWidth: 'auto',
            props: {
              placeholder: '请输入CAN总线请求ID',
            },
            itemProps: {
              rules: [
                { required: true, message: '请输入', trigger: 'blur' },
                {
                  validator: (rule, value, callback) => {
                    if (value && !/^[0-9A-F]{8}$/.test(value)) {
                      return callback(new Error("请输入8位长度16进制大写字符串"));
                    }
                    callback();
                  },
                  trigger: 'blur',
                },
              ],
            },
          },
          {
            key: 'requestCollectMethod',
            component: 'el-radio-group',
            span: 12,
            itemStyle: 1,
            itemClass: 'gray',
           
            label: '数据采集方式' + `:`,
            disableKey: 'itemCanEdit',

            data: [
              { value: 0, label: '原始数据' },
              { value: 1, label: '采集区间的平均值' },
            ],
            itemProps: {
              rules: [
                {
                  required: true,
                  message: '请选择',
                  trigger: 'change',
                },
              ],
            },
          },

          {
            key: 'responseCollectMethod',
            component: 'el-radio-group',
            span: 12,
            itemStyle: 1,
            itemClass: 'gray',
     
            label: '数据采集方式' + `:`,
            disableKey: 'itemCanEdit',
            props: {},
            data: [
              { value: 0, label: '原始数据' },
              { value: 1, label: '采集区间的平均值' },
            ],
            itemProps: {
              rules: [
                {
                  required: true,
                  message: '请选择',
                  trigger: 'change',
                },
              ],
            },
          },

          {
            key: 'requestFrameType',
            component: 'el-radio-group',
            span: 12,
            
            label: '桢类型' + `:`,
            itemStyle: 1,
            itemClass: 'gray',
            disableKey: 'itemCanEdit',
            props: {},
            data: [
              { value: 0, label: '标准桢' },
              { value: 1, label: '扩展桢' },
            ],
            itemProps: {
              rules: [
                {
                  required: true,
                  message: '请选择',
                  trigger: 'change',
                },
              ],
            },
          },
          {
            key: 'responseFrameType',
            component: 'el-radio-group',
            span: 12,
            itemClass: 'gray',
       
            label: '桢类型' + `:`,
            itemStyle: 1,
            disableKey: 'itemCanEdit',
            props: {},
            data: [
              { value: 0, label: '标准桢' },
              { value: 1, label: '扩展桢' },
            ],
            itemProps: {
              rules: [
                {
                  required: true,
                  message: '请选择',
                  trigger: 'change',
                },
              ],
            },
          },

          {
            key: 'requestChannelId',
            component: 'el-radio-group',
            span: 12,
 
            itemClass: 'gray',
            label: 'CAN通道号' + `:`,
            disableKey: 'itemCanEdit',
            itemStyle: 1,
            props: {},
            data: [
              { value: 0, label: 'CAN1' },
              { value: 1, label: 'CAN2' },
            ],
            itemProps: {
              rules: [
                {
                  required: true,
                  message: '请选择',
                  trigger: 'change',
                },
              ],
            },
          },
          {
            key: 'responseChannelId',
            component: 'el-radio-group',
            span: 12,
            itemStyle: 1,
      
            label: 'CAN通道号' + `:`,
            props: {},
            itemClass: 'gray',
            disableKey: 'itemCanEdit',
            data: [
              { value: 0, label: 'CAN1' },
              { value: 1, label: 'CAN2' },
            ],
            itemProps: {
              rules: [
                {
                  required: true,
                  message: '请选择',
                  trigger: 'change',
                },
              ],
            },
          },
        ],
      };
      this.itemList.push(model);
    }, //初始化指令
    remove(index) {
      this.itemList.splice(index, 1);
    }, //删除数据
    async getDevicesInfo() {
      let param = {
        vin: this.selectKey === 'vin' ? this.selectValue : '',
      };
      if (this.selectKey === 'vin') {
        //
        param = {
          vin: this.selectValue,
        };
      } else if (this.selectKey === 'iccid') {
        param = {
          iccid: this.selectValue,
        };
      } else {
        param = {
          sn: this.selectValue,
        };
      }

      const { data } = await getDeviceInfo(param);
      if (true === data.onlineStatus) {
        this.carState = '在线';
        this.timeChcek();
      } else {
        this.carState = '离线';
        this.dataList.splice(0, this.dataList.length);
        this.recordId = "";
        this.rightItemList = [];
        //后续还需要清空右侧的table数据
      }
    }, // 获取设备是否在线
    selectKeyChange(key) {
      if (key !== this.resetKey) {
        console.log('不一样');
        this.resetKey = key;
        this.selectValue = '';
        this.getModelList("");
        this.carState = '';
        this.initSetting();
        this.dataList.splice(0, this.dataList.length);
        this.recordId = '';
        this.$refs.nxTable.search(1);

        //清除在线的按钮 隐藏下方的所有数据  以及清楚的所有业务逻辑
      }
    }, //
    async getModelList(keyWords) {
      //if (!keyWords) return;

      let params = {};

      this.remoteLoading = true;
      this.modelList = [];
      if (this.selectKey === 'vin') {
        params = {
          pageNum: 1,
          pageSize: 10000,
          vin: keyWords,
        };
        const { data } = await getFindByVin(params);
        const list = data.list?.map((item) => {
          return {
            value: item,
            label: item,
          };
        });
        this.modelList.push.apply(this.modelList, list);
        this.remoteLoading = false;
      } else if (this.selectKey === 'iccid') {
        params = {
          pageNum: 1,
          pageSize: 10000,
          iccid: keyWords,
        };
        const { data } = await getAllIccid(params);
        this.modelList = data.list?.map((item) => {
          return {
            value: item.iccid,
            label: item.iccid,
          };
        });
        this.remoteLoading = false;
      } else {
        //  sn
        params = {
          pageNum: 1,
          pageSize: 10000,
          sn: keyWords,
        };
        const { data } = await getSnList(params);
        const modelList = data.list?.map((item) => {
          return {
            value: item,
            label: item,
          };
        });
        this.modelList.push.apply(this.modelList, modelList);
        this.remoteLoading = false;
      }
    }, //初始化el-select
  },
  beforeDestroy() {
    if (this.carStateTimer) {
      clearInterval(this.carStateTimer);
    }
  },
};
</script>

<style scoped>
.status-icon {
  position: relative;
  top: -20px;
}

.scrollable {
  width: 300px; /* 设置div的宽度 */
  height: 200px; /* 设置div的高度 */ /* 使div在垂直方向上滚动 */
}
.commonView {
  width: 100% - 40px;
  margin: 20px;
  height: 370px;

  border: 1px solid #dcdfe6;
  /* background: rgb(242, 242, 242); */
  position: relative;
}

.custom-button {
  z-index: 99;
  position: absolute;
  top: 10px; /* 距离顶部的距离 */
  right: 10px; /* 距离右侧的距离 */
}
.bottomView {
  height: 438px;
  background-color: white;
  margin-top: 20px;
  padding-top: 5px;
  /* 使div在垂直方向上滚动 */
}

.topLab {
  width: 72px;
  height: 25px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 18px;
  color: #262626;
  letter-spacing: 0;
  margin-top: 17px;
  margin-left: 19px;
  padding-left: 8px;
  border-left: 3px solid #0080f6;
}

.titelStyle {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #36383b;
  letter-spacing: 0;
}

::v-deep .el-table thead {
  background-color: rgba(47, 66, 78, 0.06) !important;
}

::v-deep .el-table th.el-table__cell {
  box-sizing: border-box;
  padding: 0 !important;
  height: 36px;
  max-height: 36px;
  background-color: rgba(47, 66, 78, 0.06) !important;
}

::v-deep .el-table--medium tbody .el-table__cell {
  box-sizing: border-box;
  padding: 0 !important;
  height: 49px !important;
  max-height: 49px !important;
  line-height: 49px !important;
  overflow: hidden;
}

::v-deep .el-table__header-wrapper {
  background-color: rgba(47, 66, 78, 0.06) !important; /* 替换为你的颜色 */
}
</style>
